// import { Navigate } from "react-router-dom";
// import { useNavigate } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import { createContext } from "react";
import { GetCustomerDetails, GetCustomerDetailsContext, validateInputExistenece } from "./App";
// import { AuthenticationContext } from "../../shared/context/AuthenticationContext";
import { useContext, useEffect, useState } from "react";
import ShimmerPage from "./pages/other-pages/ShimmerPage";
import { AuthenticationContext } from "./shared/context/AuthenticationContext";
import { getRouteFromLoanStageService } from "./shared/services/getRouteFromLoanStageService.js";

const Protected = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
//   const [customerDetails, setCustomerDetails] = useState(
//     location?.state?.customerDetails
//   );
  const { isAuthenticated, setIsAuthenticated } = useContext(
    AuthenticationContext
  );
  const authStateEncrypted = sessionStorage.getItem("eplAuth");
  const [dataCaptured, setDataCaptured] = useState(false);
  const [customerDetails, setCustomerDetails] = useContext(GetCustomerDetailsContext);

  useEffect(() => {
    // window.scrollTo(0, 0);
    // console.log("USEEFFECT-NoDependency: getCustomerDetails");
    // await GetCustomerDetails(
    // 	customerDetails.application_form_number,
    // 	customerDetails.source,
    // 	customerDetails,
    // 	setCustomerDetails
    // );
    // setDataCaptured(true);
    var getCustomerDetails = async () => {
      // console.log(".................Inside");
      await GetCustomerDetails(
        sessionStorage.getItem("application_form_no"),
        location.pathname.split("/")[1],
        customerDetails,
        setCustomerDetails,
        navigate
      );
      // console.log("DATA CAPTURING");
      setDataCaptured(true);
    };
    // console.log("Calling GetCustomerDetails");
    getCustomerDetails();
    // console.log("Called GetCustomerDetails");
  }, []);

  useEffect(() => {
    // console.log("USEEFFECT-customerDetails-1: Rerouting");
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails.full_name)
    ) {
      // console.log("\tLoanIPO customerDetails: ", customerDetails);
      // TODO: Handle Staging if needed
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("\tstage: ", customerDetails.stage);
      // console.log("\troute: ", route);
      // navigate(`${route}`, {
      // 	replace: true,
      // 	state: {
      // 		customerDetails: customerDetails,
      // 	},
      // });
    } else {
      // console.log("\tLoanIPO Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  if (authStateEncrypted === "authenticated") {
    setIsAuthenticated(true);
    // console.log(dataCaptured);
  }

  // console.log("Protected: ", { isAuthenticated });
  if (isAuthenticated === undefined || !isAuthenticated) {
    // console.log("Protected: NOT AUTH");
    if (authStateEncrypted !== "authenticated") {
      // console.log("Protected: NOT AUTH2 ");
      return navigate("/login", {
        replace: true,
      });
      // return <Login />;
    }
  }
  // console.log("Protected: children");

  return (
    <>
        {dataCaptured && children}
        {!dataCaptured && <ShimmerPage />}
    </>
  );
};
export default Protected;
